export const BE_URL = "https://ecommerce-app-ltut.onrender.com";
